<template>
    <div id="modal-buy-fast" class="modal modal-buy-fast">
        <div class="modal-body">
            <div class="modal-content">
                <a href="#" class="modal-close-btn" aria-label="Закрыть">
                    <svg width="18" height="18">
                        <use xlink:href="#icon-del"/>
                    </svg>
                </a>
                <div class="modal-title">
                    {{ config.name || config.title }} &mdash; Быстрый заказ
                </div>
                <div class="modal-desc">
                    Оставьте ваше имя, телефон и адрес доставки. Остальное обсудим по телефону.
                </div>
                <div class="modal-product">
                    <div class="modal-product-img">
                        <img v-if="config.picture" :src="config.picture"
                             :srcset="`${config.picture} 1x, ${config.picture}`"
                             :alt="config.title">
                    </div>
                    <div class="modal-product-body">
                        <div class="modal-product-title">
                            {{ config.composition }}, {{ config.size ? `${config.size} см` : '' }},
                            <span class="catalog-item-country">
                                <span>{{ config.country }}</span>
                                <i><img :src="config.countryFlag" alt=""></i>
                            </span>
                        </div>
                    </div>
                </div>
                <form ref="form" action="?" class="form modal-form order-form" @submit.prevent="send">
                    <input type="hidden" name="product" :value="config.productId">

                    <label class="form-block">
                        <span class="input-title">Имя*</span>
                        <input type="text" class="input" required v-model="name">
                    </label>
                    <label class="form-block">
                        <span class="input-title">Телефон*</span>
                        <input type="tel" class="input" required v-model="phone">
                    </label>
                    <label class="form-block form-block-textarea">
                        <span class="input-title">Адрес доставки*</span>
                        <textarea class="input textarea" required v-model="address"></textarea>
                    </label>
                    <div class="form-submit">
                        <button type="submit" class="submit btn btn-large">Отправить заказ</button>
                        <div class="form-agree">Я соглашаюсь на обработку <a href="#">персональных данных</a></div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ModalFastOrder",
    data() {
        return {
            config: {},

            name: '',
            phone: '',
            address: '',
        }
    },
    mounted() {
        let vue = this;

        $(document).on('click', '.category-item-buy-fast', function (e) {
            e.preventDefault();

            vue.config = $(this).closest('.category-item-form').data('config');

            $(vue.$refs.form).find('input, textarea').val('');
        });
    },
    methods: {
        send() {
            let formData = new FormData(),
                params = {
                    sessid: BX.bitrix_sessid(),
                    action: 'fastOrder',

                    product: this.config.productId,

                    name: this.name,
                    phone: this.phone,
                    address: this.address,

                    price: Math.round(this.config.basePrice * this.config.boxQuantity),

                    meterQuantity: this.config.meterQuantity,
                    boxQuantity: this.config.boxQuantity,
                };

            for (let key in params) {
                formData.append(key, params[key]);
            }

            axios.post('/ajax/', formData).then(response => {
                if (!response.data.success) {
                    console.error(response.data.errors.join('\n'));
                }
            });
        }
    }
}
</script>

<style scoped>

</style>